import { useNavigate } from "react-router-dom";
import { ShieldAlert } from "lucide-react";

// Page 403 générique — ne révèle aucune information sur les permissions internes.
export default function Forbidden() {
  const navigate = useNavigate();
  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4" data-testid="forbidden-page">
      <div className="max-w-md w-full text-center bg-[#18181E] border border-zinc-800 rounded-3xl p-8">
        <div className="w-14 h-14 rounded-2xl bg-zinc-800 flex items-center justify-center mx-auto mb-4">
          <ShieldAlert className="w-7 h-7 text-amber-400" />
        </div>
        <h2 className="font-display text-2xl font-extrabold">Accès non disponible</h2>
        <p className="text-sm text-zinc-400 mt-2">Cette page n'est pas accessible depuis ton espace actuel.</p>
        <button onClick={() => navigate("/dashboard")} data-testid="forbidden-home"
          className="mt-5 inline-flex items-center gap-2 px-5 h-11 rounded-xl gold-gradient text-black font-semibold hover:opacity-90">
          Retour à mon espace
        </button>
      </div>
    </div>
  );
}
